import React, { Fragment } from 'react';
import { Link } from "@remix-run/react";
import { styled } from 'styled-components';
import { Description, Image, Layout, ShadowOverlay, StyledPlayContainer, Title } from './Highlight.styles';
import { useAnalyticsDispatch } from '../../analytics/AnalyticsContext';
import { useUdpSectionTracking } from '../../analytics/use-udp-section-tracking';
import { highlightImageWidth, largeHighlightImageWidth } from '../Image/image-width';
import { PlayContainer } from '../PlayContainer/PlayContainer';
import { useSectionMeta } from '../Section/SectionMetaProvider';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// = Highlight Event

export const Highlight = ({
  highlightElementType,
  detailLink,
  linkState,
  title,
  description,
  imageUrl = '',
  focalPoint
}) => {
  const analytics = useAnalyticsDispatch();
  const sectionMeta = useSectionMeta();
  const {
    sectionId,
    representationName,
    sectionTitle
  } = sectionMeta;
  const trackSection = useUdpSectionTracking();
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      width: 'max',
      sidePadding: {
        mediaQuery: [],
        default: 0
      },
      children: /*#__PURE__*/_jsx(Link, {
        to: detailLink,
        state: linkState,
        onClick: () => {
          if (sectionId || representationName) {
            analytics({
              type: 'click-event',
              name: highlightElementType === 'Highlight' ? 'HighlightElementClick' : 'HighlightShowPageElementClick',
              value1: sectionId,
              value2: sectionTitle,
              value3: representationName
            });
            trackSection({
              sectionMeta
            });
          }
        },
        children: /*#__PURE__*/_jsxs(Layout, {
          children: [/*#__PURE__*/_jsx(Image, {
            src: imageUrl,
            width: highlightImageWidth,
            alt: title ?? '',
            largeImageWidth: largeHighlightImageWidth,
            hasBorderRadius: false,
            focalPoint: focalPoint
          }), /*#__PURE__*/_jsx(ShadowOverlay, {}), /*#__PURE__*/_jsxs(StyledPlayContainer, {
            children: [/*#__PURE__*/_jsx(Title, {
              children: title
            }), /*#__PURE__*/_jsx(Description, {
              children: description
            })]
          })]
        })
      })
    })
  });
};
const Container = styled(PlayContainer).withConfig({
  displayName: "Highlight__Container",
  componentId: "sc-kc0deb-0"
})(["position:relative;"]);